// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sortable-item {
  height: 150px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  touch-action: none;
  cursor: pointer;
}

.sortable-item.bounce {
  pointer-events: none;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  10% {
    transform: translateY(-10px);
  }
  20% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
  40% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(0);
  }
  70% {
    transform: translateY(-10px);
  }
  80% {
    transform: translateY(0);
  }
  90% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}

.bounce {
  animation: bounce 2s;
}

@keyframes bounce-effect {
  0% {
    transform: translateY(0);
  }
  10% {
    transform: translateY(-15px);
  }
  20% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-15px);
  }
  40% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
  60% {
    transform: translateY(0);
  }
  70% {
    transform: translateY(-15px);
  }
  80% {
    transform: translateY(0);
  }
  90% {
    transform: translateY(-15px);
  }
  100% {
    transform: translateY(0);
  }
}

.bounce-effect {
  animation: bounce-effect 2s infinite;
}

@media screen and (max-width: 1100px) {
  .sortable-item {
    height: 120px;
    width: 100px;
  }

  .sortable-item img {
    height: 120px;
  }
}

@media screen and (max-width: 650px) {
  .sortable-item {
    height: 100px;
    width: 100px;
  }

  .sortable-item img {
    height: 100px;
  }
}

@media screen and (max-width: 550px) {
  .sortable-item {
    height: 90px;
    width: 90px;
  }

  .sortable-item img {
    height: 90px;
  }
}

@media screen and (max-width: 500px) {
  .sortable-item {
    height: 80px;
    width: 75px;
  }

  .sortable-item img {
    height: 80px;
  }
}

@media screen and (max-width: 450px) {
  .sortable-item {
    height: 70px;
    width: 70px;
  }

  .sortable-item img {
    height: 70px;
  }
}

@media screen and (max-width: 380px) {
  .sortable-item {
    height: 60px;
    width: 60px;
  }

  .sortable-item img {
    height: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/sortableItem/SortableItem.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".sortable-item {\r\n  height: 150px;\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  touch-action: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.sortable-item.bounce {\r\n  pointer-events: none;\r\n}\r\n\r\n@keyframes bounce {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  10% {\r\n    transform: translateY(-10px);\r\n  }\r\n  20% {\r\n    transform: translateY(0);\r\n  }\r\n  30% {\r\n    transform: translateY(-10px);\r\n  }\r\n  40% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-10px);\r\n  }\r\n  60% {\r\n    transform: translateY(0);\r\n  }\r\n  70% {\r\n    transform: translateY(-10px);\r\n  }\r\n  80% {\r\n    transform: translateY(0);\r\n  }\r\n  90% {\r\n    transform: translateY(-10px);\r\n  }\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.bounce {\r\n  animation: bounce 2s;\r\n}\r\n\r\n@keyframes bounce-effect {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  10% {\r\n    transform: translateY(-15px);\r\n  }\r\n  20% {\r\n    transform: translateY(0);\r\n  }\r\n  30% {\r\n    transform: translateY(-15px);\r\n  }\r\n  40% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-15px);\r\n  }\r\n  60% {\r\n    transform: translateY(0);\r\n  }\r\n  70% {\r\n    transform: translateY(-15px);\r\n  }\r\n  80% {\r\n    transform: translateY(0);\r\n  }\r\n  90% {\r\n    transform: translateY(-15px);\r\n  }\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.bounce-effect {\r\n  animation: bounce-effect 2s infinite;\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .sortable-item {\r\n    height: 120px;\r\n    width: 100px;\r\n  }\r\n\r\n  .sortable-item img {\r\n    height: 120px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 650px) {\r\n  .sortable-item {\r\n    height: 100px;\r\n    width: 100px;\r\n  }\r\n\r\n  .sortable-item img {\r\n    height: 100px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 550px) {\r\n  .sortable-item {\r\n    height: 90px;\r\n    width: 90px;\r\n  }\r\n\r\n  .sortable-item img {\r\n    height: 90px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .sortable-item {\r\n    height: 80px;\r\n    width: 75px;\r\n  }\r\n\r\n  .sortable-item img {\r\n    height: 80px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n  .sortable-item {\r\n    height: 70px;\r\n    width: 70px;\r\n  }\r\n\r\n  .sortable-item img {\r\n    height: 70px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 380px) {\r\n  .sortable-item {\r\n    height: 60px;\r\n    width: 60px;\r\n  }\r\n\r\n  .sortable-item img {\r\n    height: 60px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
